export const initialState: MBUploadState = {
  fileUploadProgressById: {},
};

export function uploadReducer(
  state: MBUploadState = initialState,
  action: UploadAction,
): MBUploadState {
  switch (action.type) {
    case 'UPLOAD:UPDATE_FILE_UPLOAD_PROGRESS': {
      const { fileKey, progress } = action.value;
      return {
        ...state,
        fileUploadProgressById: {
          ...state.fileUploadProgressById,
          [fileKey]: progress,
        },
      };
    }

    default:
      return state;
  }
}
